<template>
<div>

<!--SideMenu-->
    <!--btn-->
    <button class="button-sidenav" v-bind:class="{_open:openMenuHmbrg}">
        <div class="inner _default" v-on:click="openMenuHmbrg=!openMenuHmbrg">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="inner _hover" v-on:click="openMenuHmbrg=!openMenuHmbrg">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="inner _close" v-on:click="closeMenuAll">
            <span></span>
            <span></span>
        </div>
    </button><!--/.btn-->

    <aside class="ly_aside">

        <div class="md_scroll-content">

            <h1>
                <a href="/"><SvgLogoAuma /></a>
            </h1>

        <!--UserData-->
            <div class="md_user-avatar-wrap">
                <div class="avatar-img">
                    <img v-if="propUser.icon" :src="$store.state.const.AWS_S3_URL_HOST + propUser.icon" alt="" class="avatar">
                    <div class="no-image">
                        <SvgIconImagePlace />
                    </div>
                </div>
                <div class="account-name">
                    <span>
                        {{companyName}}
                    </span>
                    <br>
                    <span v-if="propCompany.status == 0">
                        (休会中)
                    </span>
                </div>
                <div v-if="userType == 1 || userType == 2 || userType == 3" class="current-brand-name flex" v-on:click="openMenuBrandChange=!openMenuBrandChange">
                    <div class="name" v-if="currentListName.name">
                        <span>{{currentListName.name}}</span>
                    </div>
                    <div class="name" v-if="!currentListName.name">
                        <span>{{currentListName}}</span>
                    </div>
                    <div class="icon"><img class="md_svg-icon" src="/img/icon/reload-white.svg" alt=""></div>
                </div>
            </div><!--/.UserData-->

        <!--MenuList-->
            <nav class="menu_sidebar">
                <ul class="main">

                    <!-- 運営 -->
                    <template v-if="userType == 0" >
                        <li>
                            <a class="md_icon-text" :href="route('admin.news')" v-bind:class="{_current: isActive === 'news'}">
                                <span>
                                    お知らせ管理
                                    <div class="icon">
                                        <SvgIconNews />
                                    </div>
                                </span>
                            </a>
                        </li>
                        <li>
                            <button type="button" class="accordion md_icon-text js-toggle-on" v-bind:class="{_current: isActive === 'shop'}">
                                <span>
                                    ショップ管理
                                    <div class="icon">
                                        <div class="close">
                                            <SvgIconFolder />
                                        </div>
                                        <div class="open">
                                            <SvgIconFolderOpen />
                                        </div>
                                    </div>
                                </span>
                            </button>
                            <!--NestMenu-->
                            <ul class="nest">
                                <li>
                                    <Link class="md_icon-text" v-bind:href="route('admin.shop.company.list')" v-bind:class="{_current: isActive === 'shop'}">
                                        <span>
                                            ショップ運営会社一覧
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link class="md_icon-text" v-bind:href="route('admin.operation.shop.list')" v-bind:class="{_current: isActive === 'shop'}">
                                        <span>
                                            ショップ一覧
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <a class="md_icon-text" v-bind:href="route('admin.shop.detail.demo')" v-bind:class="{_current: isActive === 'shop'}">
                                        <span>
                                            ショップデモページ
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </a>
                                </li>
                            </ul><!--/NestMenu-->
                        </li>
                        <li>
                            <button type="button" class="accordion md_icon-text js-toggle-on"  v-bind:class="{_current: isActive === 'brand'}">
                                <span>
                                    ブランド管理
                                    <div class="icon">
                                        <div class="close">
                                            <SvgIconFolder />
                                        </div>
                                        <div class="open">
                                            <SvgIconFolderOpen />
                                        </div>
                                    </div>
                                </span>
                            </button>
                            <!--NestMenu-->
                            <ul class="nest">
                                <li>
                                    <Link class="md_icon-text" v-bind:href="route('admin.brand.company.list')" v-bind:class="{_current: isActive === 'brand'}">
                                        <span>
                                            ブランド運営会社一覧
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link class="md_icon-text" v-bind:href="route('admin.operation.brand.list')" v-bind:class="{_current: isActive === 'brand'}">
                                        <span>
                                            ブランド一覧
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <a class="md_icon-text" v-bind:href="route('admin.brand.detail.demo')" v-bind:class="{_current: isActive === 'brand'}">
                                        <span>
                                            ブランドデモページ
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </a>
                                </li>
                            </ul><!--/NestMenu-->
                        </li>
                        <li>
                            <button type="button" class="accordion md_icon-text js-toggle-on"  v-bind:class="{_current: isActive === 'showroom'}">
                                <span>
                                    ショールーム管理
                                    <div class="icon">
                                        <div class="close">
                                            <SvgIconFolder />
                                        </div>
                                        <div class="open">
                                            <SvgIconFolderOpen />
                                        </div>
                                    </div>
                                </span>
                            </button>
                            <!--NestMenu-->
                            <ul class="nest">
                                <li>
                                    <Link class="md_icon-text" v-bind:href="route('admin.showroom.company.list')" v-bind:class="{_current: isActive === 'showroom'}">
                                        <span>
                                            ショールーム運営会社一覧
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link class="md_icon-text" v-bind:href="route('admin.operation.showroom.list')" v-bind:class="{_current: isActive === 'showroom'}">
                                        <span>
                                            ショールーム一覧
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <a class="md_icon-text" v-bind:href="route('admin.showroom.detail.demo')" v-bind:class="{_current: isActive === 'showroom'}">
                                        <span>
                                            ショールームデモページ
                                            <div class="icon">
                                                <SvgIconList />
                                            </div>
                                        </span>
                                    </a>
                                </li>
                            </ul><!--/NestMenu-->
                        </li>
                    </template>

                    <!-- ショップ -->
                    <template v-if="userType == 1" >
                        <li>
                            <Link class="md_icon-text" v-bind:href="route(linkToNews)" v-bind:class="{_current: isActive === 'news'}">
                                <span>
                                    News
                                    <div class="icon">
                                        <SvgIconNews />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li>
                            <a v-if="shopPersonal" class="md_icon-text" v-bind:href="route('admin.shop.detail', currentListName.id)" v-bind:class="{_current: isActive === 'shop'}">
                                <span>
                                    Shop
                                    <div class="icon">
                                        <SvgIconShop />
                                    </div>
                                </span>
                            </a>
                            <Link v-if="!shopPersonal" class="md_icon-text" v-bind:href="route(linkToShop)" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'shop'}">
                                <span>
                                    Shop
                                    <div class="icon">
                                        <SvgIconShop />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li v-if="listData.length">
                            <Link class="md_icon-text" v-bind:href="route(linkToBrand)" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'brand'}">
                                <span>
                                    My Select Room<br>
                                    <span style="display:block; line-height: 7px; font-size: x-small;">（ブランド）</span>
                                    <div class="icon">
                                        <SvgIconBrand />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link class="md_icon-text" v-bind:href="route(linkToShowRoom)" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'showroom'}">
                                <span>
                                    My Select Room<br>
                                    <span style="display:block; line-height: 7px; font-size: x-small;">（ショールーム）</span>
                                    <div class="icon">
                                        <SvgIconBrand />
                                    </div>
                                </span>
                            </Link>
                        </li>
                    </template>

                    <!-- ブランド -->
                    <template v-if="userType == 2" >
                        <li>
                            <Link class="md_icon-text" v-bind:href="route(linkToDashboard)" v-bind:class="{_current: isActive === 'dashboard'}">
                                <span>
                                    Dashboard
                                    <div class="icon">
                                        <SvgIconDashBoard />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link class="md_icon-text" v-bind:href="route(linkToNews)" v-bind:class="{_current: isActive === 'news'}">
                                <span>
                                    News
                                    <div class="icon">
                                        <SvgIconNews />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li v-if="currentListName.plan == 1">
                            <Link class="md_icon-text" v-bind:href="route('admin.brand.dm.list')" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'dm'}">
                                <span>
                                    DM一覧
                                    <div class="icon">
                                        <SvgIconMail />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link class="md_icon-text" v-bind:href="route(linkToBrand)" v-bind:class="{_current: isActive === 'brand'}">
                                <span>
                                    Brand
                                    <div class="icon">
                                        <SvgIconBrand />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li v-if="(currentListName.plan == 1 && listData.length)">
                            <Link class="md_icon-text" v-bind:href="route(linkToShop)" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'shop'}">
                                <span>
                                    Shop
                                    <div class="icon">
                                        <SvgIconShop />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li v-if="(currentListName.plan == 1 && listData.length)">
                            <Link class="md_icon-text" v-bind:href="route(linkToShowRoom)" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'showroom'}">
                                <span>
                                    ShowRoom
                                    <div class="icon">
                                        <SvgIconBrand />
                                    </div>
                                </span>
                            </Link>
                        </li>
                    </template>

                    <!-- ショールーム -->
                    <template v-if="userType == 3">
                        <li>
                            <Link class="md_icon-text" v-bind:href="route(linkToDashboard)" v-bind:class="{_current: isActive === 'dashboard'}">
                                <span>
                                    Dashboard
                                    <div class="icon">
                                        <SvgIconDashBoard />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link class="md_icon-text" v-bind:href="route(linkToNews)" v-bind:class="{_current: isActive === 'news'}">
                                <span>
                                    News
                                    <div class="icon">
                                        <SvgIconNews />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li v-if="currentListName.plan == 1">
                            <Link class="md_icon-text" v-bind:href="route('admin.showroom.dm.list')" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'dm'}">
                                <span>
                                    DM一覧
                                    <div class="icon">
                                        <SvgIconMail />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link class="md_icon-text" v-bind:href="route(linkToShowRoom)" v-bind:class="{_current: isActive === 'showroom'}">
                                <span>
                                    ShowRoom
                                    <div class="icon">
                                        <SvgIconBrand />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li v-if="currentListName.plan == 1">
                            <Link class="md_icon-text" v-bind:href="route('admin.showroom.sales.brands')" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'sales_brands_info'}">
                                <span>
                                    Sales Brands Info
                                    <div class="icon">
                                        <SvgIconBrand />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li v-if="(currentListName.plan == 1 && listData.length)">
                            <Link class="md_icon-text" v-bind:href="route(linkToShop)" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'shop'}">
                                <span>
                                    My Select Room<br>
                                    <span style="display:block; line-height: 7px; font-size: x-small;">（ショップ）</span>
                                    <div class="icon">
                                        <SvgIconShop />
                                    </div>
                                </span>
                            </Link>
                        </li>
                        <li v-if="(currentListName.plan == 1 && listData.length)">
                            <Link class="md_icon-text" v-bind:href="route(linkToBrand)" :data="{listIndex: listIndex}" v-bind:class="{_current: isActive === 'brand'}">
                                <span>
                                    My Select Room<br>
                                    <span style="display:block; line-height: 7px; font-size: x-small;">（ブランド）</span>
                                    <div class="icon">
                                        <SvgIconBrand />
                                    </div>
                                </span>
                            </Link>
                        </li>
                    </template>

                    <li v-if="userRole == 1 || userType == 0 || shopPersonal">
                        <Link class="md_icon-text" v-bind:href="route('admin.account.set')" v-bind:class="{_current: isActive === 'setting'}">
                            <span>
                                Setting
                                <div class="icon">
                                    <SvgIconSetting />
                                </div>
                            </span>
                        </Link>
                    </li>
                    <li v-if="userRole == 0 && !shopPersonal">
                        <button type="button" class="accordion md_icon-text js-toggle-on" v-bind:class="{_current: isActive === 'setting'}">
                            <span>
                                Setting
                                <div class="icon">
                                    <div class="close">
                                        <SvgIconSetting />
                                    </div>
                                    <div class="open">
                                        <SvgIconSetting />
                                    </div>
                                </div>
                            </span>
                        </button>
                        <!--NestMenu-->
                        <ul class="nest">
                            <li>
                                <Link class="md_icon-text" v-bind:href="route('admin.account.set')" preserve-state v-bind:class="{_current: isActive === 'setting'}">
                                    <span>
                                        個人設定
                                        <div class="icon">
                                            <SvgIconSetting />
                                        </div>
                                    </span>
                                </Link>
                            </li>
                            <li>
                                <Link class="md_icon-text" v-bind:href="route(linkToTeam)" preserve-state v-bind:class="{_current: isActive === 'setting'}">
                                    <span>
                                        会社設定
                                        <div class="icon">
                                            <SvgIconSetting />
                                        </div>
                                    </span>
                                </Link>
                            </li>
                        </ul><!--/NestMenu-->
                    </li>
                </ul>
            </nav><!--/.MenuList-->

        </div>

        <button class="logout md_icon-text" v-on:click="logout()">
            <span>
                Logout
                <div class="icon">
                    <SvgIconLogout />
                </div>
            </span>
        </button>

    </aside>



<!--MenuBrandChange-->
    <nav v-if="userType == 1 || userType == 2 || userType == 3" class="menu_brand-change" v-bind:class="{_open:openMenuBrandChange}">

        <h4>
            <span v-if="userType == 1">Shop Change</span>
            <span v-if="userType == 2">Brand Change</span>
            <span v-if="userType == 3">ShowRoom Change</span>
            <div class="back" v-on:click="closeMenuBrandChange">
                <button class="md_svg-icon">
                    <img src="/img/icon/back-white.svg" alt="">
                </button>
            </div>
        </h4>

        <div class="md_scroll-content">

            <ul v-for="(list, index) in listData" v-bind:key="index">
                <li class="flex _left _y-center" v-on:click="selectList(index)">
                    <div class="avatar">
                        <img v-if="list.path" v-bind:src=" $store.state.const.AWS_S3_URL_HOST + list.path " alt="">
                        <div class="no-image">
                            <SvgIconImagePlace />
                        </div>
                    </div>
                    <div class="detail"><span>{{list.name}}</span></div>
                </li>
            </ul>

        </div><!--/.md_scroll-content-->

    </nav><!--/.BrandChangeMenu-->

</div>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3'

    //Svg
    import SvgLogoAuma from '@/components/EndUser/svg/SvgLogoAuma'
    import SvgIconNews from '@/components/EndUser/svg/SvgIconNews'
    import SvgIconBrand from '@/components/EndUser/svg/SvgIconBrand'
    import SvgIconDashBoard from '@/components/EndUser/svg/SvgIconDashBoard'
    import SvgIconShop from '@/components/EndUser/svg/SvgIconShop'
    import SvgIconList from '@/components/EndUser/svg/SvgIconList'
    import SvgIconMail from '@/components/EndUser/svg/SvgIconMail'
    import SvgIconSetting from '@/components/EndUser/svg/SvgIconSetting'
    import SvgIconLogout from '@/components/EndUser/svg/SvgIconLogout'
    import SvgIconFolder from '@/components/EndUser/svg/SvgIconFolder'
    import SvgIconFolderOpen from '@/components/EndUser/svg/SvgIconFolderOpen'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'

    export default {
        components: {
            "Link": Link,
            //Svg
            SvgLogoAuma,
            SvgIconNews,
            SvgIconBrand,
            SvgIconDashBoard,
            SvgIconShop,
            SvgIconList,
            SvgIconSetting,
            SvgIconLogout,
            SvgIconMail,
            SvgIconFolder,
            SvgIconFolderOpen,
            SvgIconImagePlace,
        },
        data() {
            return {
                // ブランドチェンジメニューを開く
                openMenuHmbrg: false,
                openMenuBrandChange: false,
                listIndex: 0,
                isActive: '',
                isActiveNest: '',
                url: '',
                user_type: '',
            }
        },
        created() {
            this.listExists = false;
            this.user_type = this.propUser.type;
            this.setCurrentClass(location.pathname);
            if (this.$store.state.const.index > 0) {
                this.listIndex = this.$store.state.const.index;
            }
        },

        mounted() {
        const shouldOpenMenu = localStorage.getItem('showHamburgerMenuAfterLogin');
            if (shouldOpenMenu === 'true') {
            this.openMenuHmbrg = true;
            localStorage.removeItem('showHamburgerMenuAfterLogin');
            }
        },

        props: {
            propUser: Object,
            propCompany: Object,
            propBrands: Object,
            propShops: Object,
        },
        methods: {
            /**
             * ブランドチェンジメニューを閉じる
             */
            closeMenuBrandChange: function (e) {
                e.preventDefault();
                this.openMenuBrandChange = false;
            },
            selectList (index) {
                this.$emit("selectList", index);
                this.listIndex = index;
                this.openMenuBrandChange = false;
                this.$store.state.const.index = index;
            },
            setCurrentClass(url) {
                switch (url) {
                    case '/admin/news':
                        this.isActive = 'news';
                        break;
                    case '/admin/shop-company':
                        this.isActive = 'shop';
                        break;
                    case '/admin/shop/operation':
                        this.isActive = 'shop';
                        break;
                    case '/admin/brand-company':
                        this.isActive = 'brand';
                        break;
                    case '/admin/brand/operation':
                        this.isActive = 'brand';
                        break;
                    case '/admin/showroom-company':
                        this.isActive = 'showroom';
                        break;
                    case '/admin/showroom/operation':
                        this.isActive = 'showroom';
                        break;
                    case '/admin/shop/news':
                        this.isActive = 'news';
                        break;
                    case '/admin/shop':
                        this.isActive = 'shop';
                        break;
                    case '/admin/shop/brands':
                        this.isActive = 'brand';
                        break;
                    case '/admin/shop/showrooms':
                        this.isActive = 'showroom';
                        break;
                    case '/admin/brand/dashboard':
                        this.isActive = 'dashboard';
                        break;
                    case '/admin/brand/news':
                        this.isActive = 'news';
                        break;
                    case '/admin/brand/dm':
                        this.isActive = 'dm';
                        break;
                    case '/admin/brand':
                        this.isActive = 'brand';
                        break;
                    case '/admin/brand/shops':
                        this.isActive = 'shop';
                        break;
                    case '/admin/brand/showrooms':
                        this.isActive = 'showroom';
                        break;
                    case '/admin/showroom/dashboard':
                        this.isActive = 'dashboard';
                        break;
                    case '/admin/showroom/news':
                        this.isActive = 'news';
                        break;
                    case '/admin/showroom/dm':
                        this.isActive = 'dm';
                        break;
                    case '/admin/showroom':
                        this.isActive = 'showroom';
                        break;
                    case '/admin/showroom/sales_brands':
                        this.isActive = 'sales_brands_info';
                        break;
                    case '/admin/showroom/shops':
                        this.isActive = 'shop';
                        break;
                    case '/admin/showroom/brands':
                        this.isActive = 'brand';
                        break;
                    case '/admin/account/set':
                        this.isActive = 'setting';
                        this.isActiveNest = 'personalSetting';
                        break;
                    case '/admin/shop/manager/team':
                    case '/admin/brand/manager/team':
                    case '/admin/showroom/manager/team':
                        this.isActive = 'setting';
                        this.isActiveNest = 'companySetting';
                        break;
                }
            },
            logout() {
                // this.$inertia.get(route('logout'));
                location.href = route('logout');
            },
            ////////////////////////////////////
            // 開いているメニューを全て閉じる
            ////////////////////////////////////
            closeMenuAll: function () {
                this.openMenuHmbrg = false;
                setTimeout(()=> {
                    this.openSearchBlock = false;
                }, 600);
            },

        },
        computed: {
            userType() {
                return this.propUser.type;
            },
            userRole() {
                return this.propUser.role;
            },
            companyName() {
                return this.propCompany.name;
            },
            listData() {
                if (this.propUser.type == 1) {
                    return this.propShops;
                } else if (this.propUser.type == 2) {
                    return this.propBrands;
                } else if (this.propUser.type == 3) {
                    return this.propBrands;
                }
            },
            currentListName() {
                if (this.propUser.type == 1 && this.propShops.length > 0) {
                    return this.propShops[this.listIndex];
                } else if (this.propUser.type == 1 && this.propShops.length == 0) {
                    this.listExists = false;
                    return 'ショップ未登録';
                } else if (this.propUser.type == 2 && this.propBrands.length > 0) {
                    return this.propBrands[this.listIndex];
                } else if (this.propUser.type == 2 && this.propBrands.length == 0) {
                    this.listExists = false;
                    return 'ブランド未登録';
                } else if (this.propUser.type == 3 && this.propBrands.length > 0) {
                    return this.propBrands[this.listIndex];
                } else if (this.propUser.type == 3 && this.propBrands.length == 0) {
                    this.listExists = false;
                    return 'ショールーム未登録';
                }
            },
            linkToDashboard() {
                if (this.propUser.type == 2) {
                    return 'admin.brand.dashboard';
                } else if (this.propUser.type == 3) {
                    return 'admin.showroom.dashboard';
                }
            },
            linkToNews() {
                if (this.propUser.type == 1) {
                    return 'admin.shop.news';
                } else if (this.propUser.type == 2) {
                    return 'admin.brand.news';
                } else if (this.propUser.type == 3) {
                    return 'admin.showroom.news';
                }
            },
            linkToBrand() {
                if (this.propUser.type == 1) {
                    return 'admin.shop.brands';
                } else if (this.propUser.type == 2) {
                    return 'admin.brand.list';
                } else if (this.propUser.type == 3) {
                    return 'admin.showroom.brands';
                }
            },
            linkToShop() {
                if (this.propUser.type == 1) {
                    return 'admin.shop.list';
                } else if (this.propUser.type == 2) {
                    return 'admin.brand.shops';
                } else if (this.propUser.type == 3) {
                    return 'admin.showroom.shops';
                }
            },
            linkToShowRoom() {
                if (this.propUser.type == 1) {
                    return 'admin.shop.showrooms';
                } else if (this.propUser.type == 2) {
                    return 'admin.brand.showrooms';
                } else if (this.propUser.type == 3) {
                    return 'admin.showroom.list';
                }
            },
            linkToTeam() {
                if (this.propUser.type == 1) {
                    return 'admin.shop.team.index';
                } else if (this.propUser.type == 2) {
                    return 'admin.brand.team.index';
                } else if (this.propUser.type == 3) {
                    return 'admin.showroom.team.index';
                }
            },
            shopPersonal() {
                if (this.propUser.type != 1) {
                    return false;
                }
                if (this.propShops.length) {
                    // shop [10:personal | 11: unit ]
                    // brand [ 0:無料 | 1:BASIC | 2: premium ]
                    if (this.propShops[0].plan == 10) {
                        return true;
                    }  else if (this.propShops[0].plan == 11) {
                        return false;
                    }
                } else {
                    // 0になる可能性があるのは削除機能のあるshop側ではunitだけ
                    return false;
                }
            },
        }
    }
</script>
